export default __webpack_public_path__ + "static/media/image_3.f1a2dad6.webp";